<template>
  <div ref="upgradeModal" class="modal animated fadeInDown dark-modal w-auto" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-center">
      <div class="modal-content">
        <div class="modal-body">
          <div class="mt-4 mb-4" style="font-size:16px;font-weight:200;">Indiefy <b>PRO</b></div>
          <div style="max-width: 160px; height: 160px; margin: 0 auto; border-radius: 50%; background: url(/static/img/mesh-gradient.png);background-size: 250%;position: relative;background-position: 57% 30%;">
            <img src="/static/img/store-modal.png" alt="" style="width: 100%;height: 100%"/>
          </div>
          <div class="mt-4">
            <b>{{ $t('more_stores') }}</b><br>
            <span style="font-size: 13px; font-weight: 200;">{{ $t('get_premium_stores') }}</span><br /><br />
            <b>{{ $t('more_features') }}</b><br>
            <span style="font-size: 13px; font-weight: 200;">{{ $t('unlock_all_features') }}</span>
          </div>
          <br>
          <div class="container-buttons mt-2">
            <router-link :to="url">
              <button class="btn btn-gradient">{{ $t('upgrade_now') }} <i class="fa fa-rocket ml-1"></i></button>
            </router-link>
            <br><br>
            <button class="btn btn-maybe" data-dismiss="modal">{{ $t('maybe_later') }}</button>
          </div>
          <br>
          <div class="text-footer mb-4" style="font-weight: 200;">
            {{ $t('suscriptions_renew_modal') }}
            <a style="font-weight: normal;" href=" https://help.indiefy.net/hc/en-us/articles/360046365893-How-can-I-cancel-my-PRO-subscription-">{{ $t('learn_more') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'UpgradeModal',
  data: function () {
    return {
      targetBlank: '',
      url: '/upgrade'
    }
  },
  methods: {
    showModal: function () {
      window.$(this.$refs.upgradeModal).modal('show')
    }
  },
  created: function () {
    this.$eventBus.$on('showUpgradeModal', (targetBlank, referrer) => {
      if (targetBlank) {
        this.targetBlank = '_blank'
      }

      if (referrer) {
        this.url = '/upgrade?from=' + referrer
      }

      this.showModal()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/UpgradeModal.vue